import React from "react";
import "./_top.scss";

const Top = () => {
  return <div id="top" className="top"></div>;
};

export default Top;
